import React, { useState } from "react";
import "./nt_spontaneous.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function NtSpontaneous(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  const [patientOne_UUId, setPatientOne_UUId] = useState("");

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || "").trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormData({
            ...formData,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
    }
  };

  const handlesubmit = () => {
    props.loaderchange("true");

    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload =
            document.getElementById("prescriptionReportWrap").innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Nt Spontaneous",
            },
          };


          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();
            
          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: "30px",
        // lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        height: "20px",
      }}
    >
      ●
    </span>
  );
  const renderIndentation = () => (
    <span
      style={{
        visibility: "hidden",
        fontSize: "30px",
        lineHeight: "20px",
      }}
    >
      ●
    </span>
  );
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };
  return (
    <div id="NtSpontaneous">
      <div className="NtSpontaneous">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px"

            }}
          > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={formData.patientId1}
                  onChange={(e) => handleChange(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.patientId1}
                </span>
              </div>
            </div> */}

          {/* Patient Name */}
          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{formData.patientName1}
              </span>
            </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={formData.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.age1}
              </span>
            </div> */}

          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={formData.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodGroup1}
              </span>
            </div> */}
          {/* </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <div className="detail">
          <p>
            OBSTETRIC H/O
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="obstetricHistory"
              onChange={handleChange}
              value={formData.obstetricHistory}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.obstetricHistory}
            </span>
          </p>
          <p>
            LMP:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="lmp"
              onChange={handleChange}
              value={formData.lmp}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.lmp}
            </span>
            ET:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="et"
              onChange={handleChange}
              value={formData.et}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.et}
            </span>
            EDD:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="edd"
              onChange={handleChange}
              value={formData.edd}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.edd}
            </span>
            POG:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pog"
              onChange={handleChange}
              value={formData.pog}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.pog}
            </span>
          </p>
          <p>
            NT SCAN
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="ntScan"
              onChange={handleChange}
              value={formData.ntScan}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.ntScan}
            </span>
            NT
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="nt"
              onChange={handleChange}
              value={formData.nt}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.nt}
            </span>
            NB
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="nb"
              onChange={handleChange}
              value={formData.nb}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.nb}
            </span>
            TR
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="tr"
              onChange={handleChange}
              value={formData.tr}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.tr}
            </span>
            DV
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="dv"
              onChange={handleChange}
              value={formData.dv}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.dv}
            </span>
          </p>
          <p>
            CERVIX:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="cervix"
              onChange={handleChange}
              value={formData.cervix}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.cervix}
            </span>
          </p>
          <p>DUAL MARKER: Given</p>
          <p>
            COMPLAINTS
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="complaints"
              onChange={handleChange}
              value={formData.complaints}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.complaints}
            </span>
          </p>
          <p>
            O/E: PALLOR-
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pallor"
              onChange={handleChange}
              value={formData.pallor}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.pallor}
            </span>
            PEDAL EDEMA-
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pedalEdema"
              onChange={handleChange}
              value={formData.pedalEdema}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.pedalEdema}
            </span>
          </p>
          <p>
            PR:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="pr"
              onChange={handleChange}
              value={formData.pr}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.pr}
            </span>
            /min,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BP:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="bp"
              onChange={handleChange}
              value={formData.bp}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.bp}
            </span>
            mmHg&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weight-
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="weight"
              onChange={handleChange}
              value={formData.weight}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.weight}
            </span>
            Pre Preg weight:
            <input
              className={`createTime ${show ? "hide" : "show"}`}
              name="prePregWeight"
              onChange={handleChange}
              value={formData.prePregWeight}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.prePregWeight}
            </span>
          </p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th> S.No</th>
              <th> DRUG</th>
              <th> DOSAGE</th>
              <th> FREQUENCY</th>
              <th> TIME TO TAKE</th>
              <th> DAYS</th>
            </tr>
            {[...Array(6).keys()].map((i) => (
              <tr key={i + 1}>
                <td>{i + 1}</td>
                <td>
                  {i + 1 === 1 && (
                    <>
                      T.TRITOFER XT/
                      <br />
                      FURNEXT/GLOBAC XT
                      <br />
                      <br />
                      (Iron supplement)
                    </>
                  )}
                  {i + 1 === 2 && (
                    <>
                      C.FOLIVISTA
                      <br />
                      <br />
                      (Folic acid supplement)
                    </>
                  )}
                  {i + 1 === 3 && (
                    <>
                      T.VEHYCAL
                      <br />
                      <br />
                      (Calcium+VitD3)
                    </>
                  )}
                  {i + 1 === 4 && <>INJ.Td VAC</>}
                  {i + 1 === 5 && (
                    <>
                      SYP.GAVISCON
                      <br />
                      <br />
                      SodiumAlginate + Sodium Bicarbonate
                      <br />
                      Calcium Carbonate
                    </>
                  )}
                  {i + 1 === 6 && <>BIO OIL</>}
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`dosage${i + 1}`}
                    onChange={handleChange}
                    value={formData[`dosage${i + 1}`]}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formData[`dosage${i + 1}`]}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`frequency${i + 1}`}
                    onChange={handleChange}
                    value={formData[`frequency${i + 1}`]}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formData[`frequency${i + 1}`]}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`timeToTake${i + 1}`}
                    onChange={handleChange}
                    value={formData[`timeToTake${i + 1}`]}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formData[`timeToTake${i + 1}`]}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`days${i + 1}`}
                    onChange={handleChange}
                    value={formData[`days${i + 1}`]}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{formData[`days${i + 1}`]}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        <br />
        <div className="bulletin">
          <ul>
            <li>
              NEXT REVIEW:
              <input
                type="date"
                className={`createTime ${show ? "hide" : "show"}`}
                name="nextReview"
                onChange={handleChange}
                value={formData.nextReview}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.nextReview}
              </span>
            </li>
            <li>INVESTIGATIONS: ATTACH DUAL MARKER REPORT</li>
            <li>
              Get your PICME number- Nearest Government Hospital with your
              Aadhar/Photographs
            </li>
            <li>
              Vomitting will settle down mostly by 14 weeks. If you still have
              vomiting, start Iron and Calcium by 14 weeks
            </li>
            <li>
              Take medications on time. Iron and Calcium tablets should have a
              gap of 4 hours
            </li>
            <li>
              Do not take Iron with Tea, coffee, biscuits as it will reduce
              absorption
            </li>
            <li>
              Report of Double marker should be given on the day of NT scan and
              the result will take around 7-10 days. Check the results with
              Dr.Aishwarya
            </li>
            <li>Should you have any emergencies call +91-9342521779</li>
            <li>Collect the diet chart</li>
            <li>
              You can start the exercise –
              walking,yoga,bicycling,swimming,jogging,Zumba
            </li>
            <li>
              DOCTOR MOMMIES YOUTUBE- 2nd trimester dos and dont’s can be
              watched
            </li>
          </ul>
        </div>
        <br />
        <br />
      </div>
      <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
      <div className={`Footer ${show ? "hide" : "show"}`}>
        <button onClick={handlesubmit} className="Button_Create">
          Add Report
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("OBSTETRIC H/O :", formData.obstetricHistory)}
            {renderReportfield("LMP :", formData.lmp)}
            {renderReportfield("ET :", formData.et)}
            {renderReportfield("EDD :", formData.edd)}
            {renderReportfield("POG :", formData.pog)}
            {renderReportfield("NT SCAN :", formData.ntScan)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("NT :", formData.nt)}
            {renderReportfield("NB :", formData.nb)}
            {renderReportfield("TR :", formData.tr)}
            {renderReportfield("DV :", formData.dv)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("DUAL MARKER: Given ")}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Complaints :", formData.complaints)}
            {renderReportfield("O/E: PALLOR :", formData.pallor)}
            {renderReportfield("PEDAL EDEMA :", formData.pedalEdema)}
            {renderReportfield("PR :", formData.pr)}/min
            {renderReportfield("BP :", formData.bp)}mmHg
            {renderReportfield("Weight :", formData.weight)}
          </div>

          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Pre Preg weight :", formData.prePregWeight)}
          </div>

          <div>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  {[
                    "S.No",
                    "DRUG",
                    "DOSAGE",
                    "FREQUENCY",
                    "TIME TO TAKE",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    sno: 1,
                    name: "T.TRITOFER XT/FURNEXT/GLOBAC XT (Iron supplement)",
                  },
                  { sno: 2, name: "C.FOLIVISTA (Folic acid supplement)" },
                  {
                    sno: 3,
                    name: "T.VEHYCAL (Calcium+VitD3)",
                  },
                  { sno: 4, name: "INJ.Td VAC" },
                  {
                    sno: 5,
                    name: "SYP.GAVISCON SodiumAlginate + Sodium Bicarbonate Calcium Carbonate",
                  },
                  {
                    sno: 6,
                    name: "BIO OIL",
                  },
                ].map((drug, i) => (
                  <tr key={i}>
                    {renderTableTD(drug.sno)}
                    {renderTableTD(drug.name)}

                    {renderTableTD(formData[`dosage${i + 1}`])}

                    {renderTableTD(formData[`frequency${i + 1}`])}

                    {renderTableTD(formData[`timeToTake${i + 1}`])}

                    {renderTableTD(formData[`days${i + 1}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield("NEXT REVIEW :", formData.nextReview)}
          </div>
          {[
            "INVESTIGATIONS: ATTACH DUAL MARKER REPORT",
            "Get your PICME number- Nearest Government Hospital with your Aadhar/Photographs",
            "Vomitting will settle down mostly by 14 weeks. If you still have vomiting, start Iron and Calcium by 14 weeks",
            "Take medications on time. Iron and Calcium tablets should have a gap of 4 hours",
            "Do not take Iron with Tea, coffee, biscuits as it will reduce absorption",
            "Report of Double marker should be given on the day of NT scan and the result will take around 7-10 days. Check the results with Dr.Aishwarya",
            "Should you have any emergencies call +91-9342521779",
            "Collect the diet chart",
            "You can start the exercise – walking,yoga,bicycling,swimming,jogging,Zumba",
            "DOCTOR MOMMIES YOUTUBE- 2nd trimester dos and dont’s can be watched",
          ].map((ele, ind) => {
            return (
              <div style={{ display: "flex", marginBottom: "10px" }}>
                {renderIndentation()}
                {renderDiscPoint()}
                {renderReportfield(ele)}
              </div>
            );
          })}
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
